export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 bg-gradient-to-br from-primary-600 to-primary-800 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 text-white/90 text-xs font-medium mb-4">
              <i className="ri-smartphone-line"></i>
              移动追剧
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">随时随地 · 追剧不停</h2>
            <p className="mt-3 text-white/80 text-sm leading-relaxed max-w-md mx-auto lg:mx-0">
              8090影院移动端全面适配，无论你在地铁、午休还是旅途中，
              打开手机就能享受影院级高清画质。智能流量优化，4G也能流畅追剧，
              让你随时随地沉浸在精彩剧情中。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-primary-700 font-semibold text-sm rounded-lg hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 版本
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm text-white font-medium text-sm rounded-lg border border-white/20 hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line text-lg"></i>
                Android 版本
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-full lg:w-[340px] px-8 lg:px-0 lg:pr-14 pb-8 lg:pb-0">
            <div className="relative mx-auto w-56">
              <div className="aspect-[9/16] rounded-2xl overflow-hidden border-4 border-white/20 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20smartphone%20mockup%20displaying%20a%20modern%20video%20streaming%20app%20interface%20with%20drama%20posters%20and%20play%20buttons%2C%20clean%20dark%20theme%20UI%20design%2C%20cinematic%20thumbnails%20in%20grid%20layout%2C%20professional%20app%20screen%20presentation%20with%20warm%20accent%20colors%2C%20isolated%20on%20transparent%20background%2C%20minimalist%20tech%20aesthetic%2C%20high%20quality%20device%20mockup%20with%20soft%20shadows&width=600&height=1066&seq=app-mockup-phone-01&orientation=portrait"
                  alt="8090影院移动端界面展示"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}